


















import Vue from 'vue';
import fieldsBase from './helpers/fields.base';

export default Vue.extend({
  name: 'input-component',
  extends: fieldsBase,
  props: ['type', 'disabled', 'step'],
  mounted(): void {
  }
});
